import { render, staticRenderFns } from "./channelAbilityEvaluation.vue?vue&type=template&id=6950def0&scoped=true"
import script from "./channelAbilityEvaluation.vue?vue&type=script&lang=js"
export * from "./channelAbilityEvaluation.vue?vue&type=script&lang=js"
import style0 from "./channelAbilityEvaluation.vue?vue&type=style&index=0&id=6950def0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6950def0",
  null
  
)

export default component.exports